import * as yup from "yup";
import i18n from "~/i18n";

export const DependencyFormValidator = yup.object().shape({
  dependencyId: yup.number().required(),
  created_from: yup.string().required(i18n.t("Task is required")),
  isParent: yup.boolean().required(),
});
